import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-fullscreen-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "project-view"
}
const _hoisted_3 = { class: "project-view-left" }
const _hoisted_4 = { class: "section settings" }
const _hoisted_5 = { class: "section-sub" }
const _hoisted_6 = { class: "section-sub" }
const _hoisted_7 = { class: "section-sub buttons" }
const _hoisted_8 = { class: "section mixes" }
const _hoisted_9 = { class: "mix-name" }
const _hoisted_10 = { class: "mix-description" }
const _hoisted_11 = {
  key: 0,
  class: "section-sub mixes-empty"
}
const _hoisted_12 = { class: "section-sub buttons" }
const _hoisted_13 = { class: "section danger" }
const _hoisted_14 = { class: "section-sub buttons" }
const _hoisted_15 = { class: "project-view-right" }
const _hoisted_16 = { class: "section tracks" }
const _hoisted_17 = { class: "project-view-track-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_file_drop = _resolveComponent("file-drop")!
  const _component_progress_track_list_item = _resolveComponent("progress-track-list-item")!
  const _component_track_list_item = _resolveComponent("track-list-item")!
  const _component_confirm = _resolveComponent("confirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_loading, null, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Loading...", -1)
            ]))]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("legend", null, "Settings", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("label", null, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("label", null, "Tempo", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  type: "number",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempo) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.tempo]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Save Settings ")
              ])
            ]),
            _createElementVNode("section", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("legend", null, "Mixes", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.mixes, (mix) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: mix._id,
                  class: "section-sub project-mix"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: `/mixes/${mix._id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.project.name) + " Mix v" + _toDisplayString(mix.version), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createTextVNode(" by " + _toDisplayString(mix.author.first_name) + " " + _toDisplayString(mix.author.last_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(mix.description || "no description"), 1)
                ]))
              }), 128)),
              (_ctx.project.mixes.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("div", null, "No mixes yet", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createMix && _ctx.createMix(...args)), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Create new ")
              ])
            ]),
            _createElementVNode("section", _hoisted_13, [
              _cache[12] || (_cache[12] = _createElementVNode("legend", null, "Danger", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.deleteConfirm = true), ["prevent","stop"])),
                  class: "btn-outline btn-danger"
                }, " Destroy Project ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("section", _hoisted_16, [
              _cache[13] || (_cache[13] = _createElementVNode("legend", null, "Tracks", -1)),
              _createVNode(_component_file_drop, { onFiles: _ctx.onDropFiles }, null, 8, ["onFiles"]),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progressTracks, (track) => {
                  return (_openBlock(), _createBlock(_component_progress_track_list_item, {
                    key: track.name,
                    track: track
                  }, null, 8, ["track"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.tracks, (track) => {
                  return (_openBlock(), _createBlock(_component_track_list_item, {
                    key: track._id,
                    track: track,
                    onDelete: _ctx.onDeleteTrack
                  }, null, 8, ["track", "onDelete"]))
                }), 128))
              ])
            ])
          ])
        ])),
    (_ctx.deleteConfirm)
      ? (_openBlock(), _createBlock(_component_confirm, {
          key: 2,
          title: "Destroy Project",
          onOk: _ctx.destroyProject,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteConfirm = false))
        }, null, 8, ["onOk"]))
      : _createCommentVNode("", true)
  ], 64))
}